import React from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import PageSettingsLanguagePills from '../components/PageSettingsLanguagePills';
import useQuery from '../../modules/react/hooks/useQuery';

const GET_DATA = gql`
  query PageSettingsLanguages($id: ID!) {
    page(id: $id) {
      ...PageSettingsLanguagesPage
    }
  }
  ${PageSettingsLanguagePills.fragments.page}
`;

const propTypes = {
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedPageId: PropTypes.string.isRequired,
  selectLanguage: PropTypes.func.isRequired,
};
const defaultProps = {};

const PageSettingsLanguages = ({
  languages,
  selectedPageId,
  selectLanguage,
}) => {
  const { data, loading, error } = useQuery(
    GET_DATA,
    {
      variables:
      { id: selectedPageId },
    },
  );

  if (loading) {
    return (
      <div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!data || error) {
    return null;
  }

  const currentPage = {
    id: data.page.id,
    locale: data.page.locale,
  };

  const pages = [
    currentPage,
    ...data.page.siblings,
  ];

  return (
    <PageSettingsLanguagePills
      selectedPage={currentPage}
      languages={languages}
      pages={pages}
      selectLanguage={selectLanguage}
    />
  );
};

PageSettingsLanguages.propTypes = propTypes;
PageSettingsLanguages.defaultProps = defaultProps;

export default PageSettingsLanguages;
